import React from "react";

const CustomerTable = ({ customers }) => {
    const isEmpty = !Array.isArray(customers) || customers.length === 0;

    return (
        <div className="p-6 bg-white shadow-lg rounded-2xl">
            <h2 className="text-2xl font-semibold mb-4">Customer Table</h2>

            {isEmpty ? (
                <div className="text-gray-500 italic">No customer data available.</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full table-auto border border-gray-200">
                        <thead className="bg-gray-100">
                            <tr>
                                {[
                                    "Customer ID",
                                    "Recency",
                                    "Frequency",
                                    "Monetary",
                                    "R",
                                    "F",
                                    "M",
                                    "RFM Score",
                                    "Segment",
                                ].map((header) => (
                                    <th
                                        key={header}
                                        className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b"
                                    >
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {customers.map((customer) => (
                                <tr key={customer.CustomerID} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border-b">{customer.CustomerID}</td>
                                    <td className="px-4 py-2 border-b">{customer.Recency}</td>
                                    <td className="px-4 py-2 border-b">{customer.Frequency}</td>
                                    <td className="px-4 py-2 border-b">
                                        ${customer.Monetary?.toFixed(2) ?? "0.00"}
                                    </td>
                                    <td className="px-4 py-2 border-b">{customer.R}</td>
                                    <td className="px-4 py-2 border-b">{customer.F}</td>
                                    <td className="px-4 py-2 border-b">{customer.M}</td>
                                    <td className="px-4 py-2 border-b">{customer.RFMScore}</td>
                                    <td className="px-4 py-2 border-b">{customer.Segment}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CustomerTable;
